export default __webpack_public_path__ + "static/media/banner-bg.92d92e65.svg";